import React, { Component } from 'react'

import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,  MDBBreadcrumb, MDBBreadcrumbItem } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBJumbotron, MDBBox } from 'mdbreact';
import { MDBTable, MDBTableBody, MDBTableHead,  } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';
//import Login from './Login';
import Axios from 'axios'
import { URL } from '../../api';
import logo from '../img/logokpru.png'
import FadeIn from 'react-fade-in';
import p1 from '../img/1656587759_2-illustration_png.png'
import p2 from '../img/1656587759_4-illustration_png.png'
import p3 from '../img/1656587761_12-illustration_png.png'
import Iframe from 'react-iframe'
import { api } from '../../api';

import { HorizontalBar } from 'react-chartjs-2';


import Swal from 'sweetalert2'
import {
  MDBTypography,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText
} from 'mdbreact';

var xlsx = require("xlsx");


export default class Editpasswordmember extends Component {


  constructor(props) {
    super(props);
    this.state = {
      value: '',
      Psaaword: '',
      modal: false,
      collapse: false,
      isWideEnough: false,
      datastuKamphaengphet:[],
      team: '2565',

      dataname:'',
      datausername:'',
      datapassword:'',
      dataid_user:'',

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onClick2 = this.onClick2.bind(this);
    this.readUploadFile = this.readUploadFile.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);


  }

  handleSubmit() {
 
      const datafrm = new FormData(); 
      datafrm.append("datapassword", this.state.datapassword);
      datafrm.append("dataid_user", this.state.dataid_user);

        Axios.post("https://git.kpru.ac.th/FrontEnd_Info/index/updatepassword",datafrm,{
              headers: {
                  'content-type': 'multipart/form-data'
              }
            })
          .then(res => {
                if (res.status === 200) {
                     
                          Swal.fire({
                                title: 'อัพเดทข้อมูลสำเร็จ',
                                icon: 'success',
                              // showCancelButton: true,
                                confirmButtonText: 'ตกลง',
                              // cancelButtonText: 'No, keep it'
                              }).then((result) => {
                              
                              })
                      
                }
          })   
 

        
  }


  componentDidMount() {

    Axios.get('https://git.kpru.ac.th/FrontEnd_Info/index/getcouncilmemberdata/'+localStorage.getItem('admin_type'))
    .then((res) => {
         console.log(res.data)
       this.setState({ dataname: res.data[0].name , datausername: res.data[0].username, datapassword: res.data[0].password , dataid_user: res.data[0].id_user  })
    })


  }

 onClick2() {
     console.log('dd')
          Axios.get('https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json')
         .then((res) => {
      //  console.log(res.data)
       
        this.setState({ datastuKamphaengphet: res })
    })

  }



  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }


  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  handleChange(event) { this.setState({ datapassword: event.target.value }); }

  handleChange2(event) { this.setState({ Psaaword: event.target.value }); }


  update = () => {
    this.setState({
      name: "",
      lname: ""
    })
  }

  readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = xlsx.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = xlsx.utils.sheet_to_json(worksheet);
         //   console.log(json);
            this.setState({ datastuKamphaengphet: json })

        };
        reader.readAsArrayBuffer(e.target.files[0]);
    }
}


  render() {
    const dUrl = "https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json";

   console.log(this.state.datapassword);
   console.log(this.props.location.pathname )
 //console.log('dd')

    return (

      <MDBContainer fluid>
       
        <MDBRow >
          <MDBCol md="12">
            <div>
           
              <FadeIn>
              <MDBJumbotron className="p-4" fluid >
                 
                <MDBTypography blockquote bqColor='primary' className='h-0'>
                  <MDBIcon icon="user-injured" />   แก้ไขรหัสผ่าน
                </MDBTypography>
                {/* <MDBTypography note noteColor='primary' noteTitle='ด้านนักศึกษา '> </MDBTypography> */}
                    <MDBBreadcrumb>
                        <MDBBreadcrumbItem>Home</MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>แก้ไขรหัสผ่าน</MDBBreadcrumbItem>
                        {/* <MDBBreadcrumbItem active>นำเข้าข้อมูลผลงานวิจัย</MDBBreadcrumbItem> */}
                    </MDBBreadcrumb>
                    <div className='text-right'> <a href='/welcome'><MDBBtn  color="blue-grey" size='sm'><MDBIcon icon="caret-left" /> กลับหน้าหลัก</MDBBtn></a>
                    {/* <MDBBtn  color="mdb-color" size='sm' onClick={this.refreshPage}><MDBIcon icon="redo" /> refresh</MDBBtn> */}
                    </div>
             
                            <br/>
                            <MDBRow>
                            <MDBCol></MDBCol>
                            <MDBCol>
                                        <form>
                                          
                                            <div className="form-group">
                                            <label htmlFor="formGroupExampleInput">ชื่อ-สกุล</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="formGroupExampleInput"
                                                value={this.state.dataname}
                                                disabled
                                            />
                                            </div>
                                            <div className="form-group">
                                            <label htmlFor="formGroupExampleInput">บัญชีผู้ใช้</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="formGroupExampleInput"
                                                value={this.state.datausername}
                                                disabled
                                            />
                                            </div>
                                            <div className="form-group">
                                            <label htmlFor="formGroupExampleInput">รหัสผ่าน</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="formGroupExampleInput"
                                                value={this.state.datapassword}
                                                onChange={this.handleChange}
                                            />
                                            </div>
                                            <MDBBtn color="indigo" onClick={this.handleSubmit} >แก้ไขรหัสผ่าน</MDBBtn>
                                        </form>

                            </MDBCol>
                            <MDBCol></MDBCol>
                        </MDBRow>

                            
<br/>


{/* {this.state.datastuKamphaengphet.length !== 0 ?<>
<p>ตัวอย่างข้อมูล {this.state.datastuKamphaengphet.length} รายการ</p>
  <MDBTable small style={{ border: "1px" }} border width="100%">
                            <MDBTableHead  >
                                <tr  >
                                    <th>ลำดับ</th>
                                    <th>รหัส</th>
                                    <th>ชื่องานวิจัย</th>
                                    <th>ปีที่เสร็จ</th>
                                    <th>ปีที่เริ่ม</th>
                                    <th>สาขาวิจัย</th>
                                    <th>สอดคล้อง</th>
                                    <th>สาขาวิชา</th>
                                    <th>คณะ</th>
                                   
                                   
                                </tr>
                            </MDBTableHead>


                            <MDBTableBody>
                                {this.state.datastuKamphaengphet.map((data,index) => {
                                    return <tr>
                                        <td>{index+1} </td>
                                        <td>{data.ResearchID}</td>
                                        <td>{data.ResearchName}</td>
                                        <td>{data.Year}</td>
                                        <td>{data.Yr}</td>
                                        <td>{data.FieldName}</td>
                                        <td>{data.research_concerned}</td>
                                        <td>{data.Programe}</td>
                                        <td>{data.faculty}</td>
                                       
                                      
                                    </tr>
                                })}
                            </MDBTableBody>
                        </MDBTable>
<div  className='text-center'>
     <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
</div>
                     
</>:<>

</>} */}
                        
              </MDBJumbotron>

       

              </FadeIn>
            </div>
          </MDBCol>
        </MDBRow>

      </MDBContainer>


    )
  }
}
